import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import Select from "react-select";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import InjuryAssessment from "./InjuryAssessment";
import Diagnosis from "./Diagnosis";
import Treatment from "./Treatment";
import InjAsmntTabs from "./OverallAssmnt/AsmntTabs";

const Injury = () => {

    const [athleteId, setAthleteId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [injuryId, setInjuryId] = useState("");
    const [dateOfInjury, setDateOfInjury] = useState("");
    const [onset, setOnset] = useState("");
    const [painLvl, setPainLvl] = useState("");
    const [symptomSummary, setSymptomSummary] = useState("");
    const [symptomType, setSymptomType] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [painLocation, setPainLocation] = useState<any[]>([]);
    const [functionalLimitations, setFunctionalLimitations] = useState<any[]>([]);
    const [treatment, setTreatment] = useState("");
    const [concussionSymp, setConcussionSymp] = useState<any[]>([]);
    const [injuryList, setInjuryList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [onsetList, setOnsetList] = useState<any[]>([]);
    const [symptomList, setSymptomList] = useState<any[]>([]);
    const [painLocationList, setPainLocationList] = useState<any[]>([]);
    const [functionalLimitList, setFunctionalLimitList] = useState<any[]>([]);
    const [concussionSympList, setConcussionSympList] = useState<any[]>([]);
    const [treatmentList, setTreatmentList] = useState<any[]>([]);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showAssessmentModal, setShowAssessmentModal] = useState(false);
    const [showDiagnosisModal, setShowDiagnosisModal] = useState(false);
    const [showTreatModal, setShowTreatModal] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const roleId = localStorage.getItem("RoleId");

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchInjury();
    }, [])

        async function fetchInjury() {
            setIsLoading(true);
            const injuryResponse = await func.listInjury(null);
            console.log("injuryResponse", typeof(injuryResponse))
            setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : []);
            const response = await func.listActiveAthletes();
            setAthleteList(Array.isArray(response) ? response : [])
            const treatResponse = await func.injuryTreatmentType(null);
            setTreatmentList(Array.isArray(treatResponse) ? treatResponse : [])
            setIsLoading(false);
            setShowTable(true);
        }

    const filteredData = injuryList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateOfInjury)}</span>
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const symptomTypeNameRender = (rowData) => {
        return <span>{rowData.symptomTypeName}</span>
    };

    const painLocationNameRender = (rowData) => {
        return <span>{rowData.painLocationName}</span>
    };

    const functionalLimitationsNameRender = (rowData) => {
        return <span>{rowData.functionalLimitationsName}</span>
    };

    const treatmentNameRender = (rowData) => {
        return <span>{rowData.treatmentName}</span>
    };

    const concussionSpecficNameRender = (rowData) => {
        return <span>{rowData.concussionSpecficSymptomName}</span>
    };

    const injuryStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" className="dropdown-item" onClick={() => editInjury(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.injuryId;
        return (
            <Link to="#" className="dropdown-item" onClick={() => deleteInjury(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newInjury() {
        const onsetResponse = await func.onset(null);
        setOnsetList(Array.isArray(onsetResponse) ? onsetResponse : [])
        const sympResponse = await func.symptomType(null);
        setSymptomList(Array.isArray(sympResponse) ? sympResponse : [])
        const painResponse = await func.painLocationType(null);
        setPainLocationList(Array.isArray(painResponse) ? painResponse : [])
        const lmtResponse = await func.functionalLimitationsType(null);
        setFunctionalLimitList(Array.isArray(lmtResponse) ? lmtResponse : [])
        const conResponse = await func.concussionSpecificSymptom(null);
        setConcussionSympList(Array.isArray(conResponse) ? conResponse : [])
        setIsEdit(false)
        setOpenModal(true)
        setAthleteId("");
        setCenterId("");
        setDateOfInjury("");
        setOnset("");
        setPainLvl("");
        setSymptomSummary("");
        setSymptomType([]);
        setPainLocation([]);
        setFunctionalLimitations([]);
        setTreatment("");
        setConcussionSymp([]);
    }

    async function editInjury(rowData: { injuryId: any; }) {
        const injuryId = rowData.injuryId;
        const onsetResponse = await func.onset(null);
        setOnsetList(Array.isArray(onsetResponse) ? onsetResponse : [])
        const sympResponse = await func.symptomType(null);
        setSymptomList(Array.isArray(sympResponse) ? sympResponse : [])
        const painResponse = await func.painLocationType(null);
        setPainLocationList(Array.isArray(painResponse) ? painResponse : [])
        const lmtResponse = await func.functionalLimitationsType(null);
        setFunctionalLimitList(Array.isArray(lmtResponse) ? lmtResponse : [])
        const conResponse = await func.concussionSpecificSymptom(null);
        setConcussionSympList(Array.isArray(conResponse) ? conResponse : [])
        const getDetails = await func.injury(injuryId);
        setInjuryId(getDetails.injuryId);
        setAthleteId(getDetails.athleteId);
        setDateOfInjury(getDetails.dateOfInjury);
        setFunctionalLimitations(getDetails.functionalLimitations);
        setOnset(getDetails.onset);
        setPainLvl(getDetails.painLevel);
        setSymptomSummary(getDetails.symptomSummary);
        setSymptomType(getDetails.symptomType);
        setPainLocation(getDetails.painLocation);
        setTreatment(getDetails.treatment);
        setConcussionSymp(getDetails.concussionSpecficSymptom);
        setIsEdit(true);
        setOpenModal(true);
    }

    function deleteInjury(injuryId: string) {
        const delteInjury = api.Injury + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjury();
            } else {
                const formData = new FormData();
                formData.append("athleteId", athleteId);
                formData.append("dateOfInjury", dateOfInjury);
                formData.append("onset", onset);
                formData.append("painLevel", painLvl);
                formData.append("symptomSummary", symptomSummary);
                formData.append("symptomType", JSON.stringify(symptomType));
                formData.append("painLocation", JSON.stringify(painLocation));
                formData.append("functionalLimitations", JSON.stringify(functionalLimitations));
                formData.append("treatment", treatment);
                formData.append("concussionSpecficSymptom", JSON.stringify(concussionSymp));
                const createInjury = api.Injury;
                fetch(createInjury, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchInjury();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }

    }

    function updateInjury() {
        const formData = new FormData();
        formData.append("athleteId", athleteId);
        formData.append("dateOfInjury", dateOfInjury);
        formData.append("onset", onset);
        formData.append("painLevel", painLvl);
        formData.append("symptomSummary", symptomSummary);
        formData.append("symptomType", JSON.stringify(symptomType));
        formData.append("painLocation", JSON.stringify(painLocation));
        formData.append("functionalLimitations", JSON.stringify(functionalLimitations));
        formData.append("treatment", treatment);
        formData.append("concussionSpecficSymptom", JSON.stringify(concussionSymp));
        const updateInjury = api.Injury + "/" + injuryId;
        fetch(updateInjury, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchInjury();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function assessModal(rowData) {
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setShowAssessmentModal(true)
        setShowDiagnosisModal(false)
        setShowTreatModal(false)
    }

    function diagModal(rowData) {
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setShowAssessmentModal(false)
        setShowDiagnosisModal(true)
        setShowTreatModal(false)
    }

    function treatModal(rowData) {
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setShowAssessmentModal(false)
        setShowDiagnosisModal(false)
        setShowTreatModal(true)
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Injury</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjury() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="row">
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const injuryResponse = await func.listInjury(e.value);
                                                    setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : []);
                                                    setShowTable(true)
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">List Injuries by</label>
                                            <Select
                                                value={treatmentList.find(treat => treat.injuryTreatmentTypeId === treatment) ? {
                                                    value: treatment,
                                                    label: treatmentList.find(treat => treat.injuryTreatmentTypeId === treatment)?.name
                                                } : null}
                                                onChange={async (e) => {
                                                    setTreatment(e.value)
                                                    const injuryResponse = await func.listInjury(e.value);
                                                    setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : []);
                                                    setShowTable(true)
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Stage"
                                                options={treatmentList.map(treat => ({
                                                    value: treat.injuryTreatmentTypeId,
                                                    label: treat.name
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {/* {(showTable &&
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete Name"
                                                    body={athleteNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateOfInjury"
                                                    header="Date Of Injury"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="symptomTypeName"
                                                    header="Symptom Type"
                                                    body={symptomTypeNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="painLocationName"
                                                    header="Pain Location"
                                                    body={painLocationNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="functionalLimitationsName"
                                                    header="Functional Limitations"
                                                    body={functionalLimitationsNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="treatmentName"
                                                    header="Treatment Name"
                                                    body={treatmentNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="concussionSpecficSymptomName"
                                                    header="Concussion Specific Symptom"
                                                    body={concussionSpecficNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )} */}

                            {(showTable &&
                                <div className="row">
                                    {filteredData.map((inj, index) => (
                                        <>
                                            <div className="col-lg-3">
                                                <div className="card">
                                                    <div className="card-header d-flex justify-content-between">
                                                        <h5 className="text-center">{inj.athleteName}</h5>
                                                        <div className="dropdown dropdown-action table-drop-action">
                                                            <Link to="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-ellipsis-v" /></Link>
                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                {currentPermissions.includes("edit") &&
                                                                    editDetails(inj)
                                                                }
                                                                {currentPermissions.includes("delete") &&
                                                                    deleteDetails(inj)
                                                                }
                                                                {["1", "2", "12"].includes(roleId) && (
                                                                    <>
                                                                        <Link className="dropdown-item" to="#" onClick={() => assessModal(inj)}><i className="fas fa-bar-chart" />Injury Assessment</Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => diagModal(inj)}><i className="fas fa-medkit" />Diagnosis</Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => treatModal(inj)}><i className="fas fa-user-md" />Treatment Plan</Link>

                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <label className="form-label"><h6>Date of Injury</h6></label>
                                                        <p>{formatDate(inj.dateOfInjury)}</p>
                                                        <label className="form-label"><h6>Symptom Type</h6></label>
                                                        <p>{inj.symptomTypeName}</p>
                                                        <label className="form-label"><h6>Pain Location</h6></label>
                                                        <p>{inj.painLocationName}</p>
                                                        <label className="form-label"><h6>Functional Limitations</h6></label>
                                                        <p>{inj.functionalLimitationsName}</p>
                                                        <label className="form-label"><h6>Treatment Name</h6></label>
                                                        <p>{inj.treatmentName}</p>
                                                        <label className="form-label"><h6>Concussion Specific Symptom</h6></label>
                                                        <p>{inj.concussionSpecficSymptomName}</p>
                                                    </div>
                                                </div>
                                            </div >
                                        </>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >

            <Modal
                show={openModal}
                size="xl"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Injury</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            {/* <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Center</label>
                                    <Select
                                        value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                            value: centerId,
                                            label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                        } : null}
                                        onChange={async (e) => {
                                            setCenterId(e.value);
                                            const response = await func.listCenterActiveAthletes(e.value);
                                            setAthleteList(Array.isArray(response) ? response : [])
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Center"
                                        options={centerList.map(cntr => ({
                                            value: cntr.geoCenterId,
                                            label: cntr.geoCenterName
                                        }))}>
                                    </Select>
                                </div>
                            </div> */}
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Athlete</label>
                                    <Select
                                        value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                            value: athleteId,
                                            label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                        } : null}
                                        onChange={async (e) => {
                                            setAthleteId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Athlete"
                                        options={athleteList.map(athlt => ({
                                            value: athlt.userId,
                                            label: athlt.athleteName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Date Of Injury</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateOfInjury"
                                        value={dateOfInjury}
                                        onChange={(e) => { setDateOfInjury(e.target.value) }}
                                        placeholder="Enter Date of Injury" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Onset</label>
                                    <Select
                                        value={onsetList.find(onst => onst.onsetId === onset) ? {
                                            value: onset,
                                            label: onsetList.find(onst => onst.onsetId === onset).name
                                        } : null}
                                        onChange={async (e) => {
                                            setOnset(e.value)
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Onset"
                                        options={onsetList.map(onst => ({
                                            value: onst.onsetId,
                                            label: onst.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Pain Level</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control"
                                        name="painlevel"
                                        required
                                        value={painLvl}
                                        onChange={(e) => { setPainLvl(e.target.value) }}
                                        placeholder="Enter Pain level(scale 1-10)" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Symptom Summary</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="sympsumry"
                                        value={symptomSummary}
                                        required
                                        onChange={(e) => { setSymptomSummary(e.target.value) }}
                                        placeholder="Enter Symptom Summary" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Symptom Type</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(symptomList)
                                            ? symptomList
                                                .filter(symp => symptomType.includes(symp.symptomTypeId))
                                                .map(symp => ({
                                                    value: symp.symptomTypeId,
                                                    label: symp.name
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setSymptomType(selectedIds);
                                        }}
                                        options={Array.isArray(symptomList)
                                            ? symptomList.map(symp => ({
                                                value: symp.symptomTypeId,
                                                label: symp.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Pain Location</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(painLocationList)
                                            ? painLocationList
                                                .filter(pan => painLocation.includes(pan.painLocationTypeId))
                                                .map(pan => ({
                                                    value: pan.painLocationTypeId,
                                                    label: pan.name
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setPainLocation(selectedIds);
                                        }}
                                        options={Array.isArray(painLocationList)
                                            ? painLocationList.map(pan => ({
                                                value: pan.painLocationTypeId,
                                                label: pan.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Functional Limitations</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(functionalLimitList)
                                            ? functionalLimitList
                                                .filter(limit => functionalLimitations.includes(limit.functionalLimitationsTypeId))
                                                .map(limit => ({
                                                    value: limit.functionalLimitationsTypeId,
                                                    label: limit.name
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setFunctionalLimitations(selectedIds);
                                        }}
                                        options={Array.isArray(functionalLimitList)
                                            ? functionalLimitList.map(limit => ({
                                                value: limit.functionalLimitationsTypeId,
                                                label: limit.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Treatment</label>
                                    <Select
                                        value={treatmentList.find(treat => treat.injuryTreatmentTypeId === treatment) ? {
                                            value: treatment,
                                            label: treatmentList.find(treat => treat.injuryTreatmentTypeId === treatment)?.name
                                        } : null}
                                        onChange={async (e) => {
                                            setTreatment(e.value)
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Treatment"
                                        options={treatmentList.map(treat => ({
                                            value: treat.injuryTreatmentTypeId,
                                            label: treat.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Concussion-Specific Symptoms</label>
                                    <Select
                                        isMulti
                                        value={Array.isArray(concussionSympList)
                                            ? concussionSympList
                                                .filter(conc => concussionSymp.includes(conc.concussionSpecificSymptomId))
                                                .map(conc => ({
                                                    value: conc.concussionSpecificSymptomId,
                                                    label: conc.name
                                                }))
                                            : []
                                        }
                                        styles={customSelect}
                                        required
                                        onChange={(selectedOptions) => {
                                            // const selectedIds = selectedOptions.map(option => option.value);
                                            const selectedIds = Array.isArray(selectedOptions)
                                                ? selectedOptions.map(option => option.value)
                                                : selectedOptions
                                                    ? [selectedOptions.value]
                                                    : [];
                                            setConcussionSymp(selectedIds);
                                        }}
                                        options={Array.isArray(concussionSympList)
                                            ? concussionSympList.map(conc => ({
                                                value: conc.concussionSpecificSymptomId,
                                                label: conc.name
                                            }))
                                            : []
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>

            <Modal
                show={showAssessmentModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">Injury Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShowAssessmentModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody
                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                >
                    <InjuryAssessment athltId={athleteId} injId={injuryId} />
                    {/* <InjAsmntTabs athltId={athleteId} injId={injuryId} /> */}
                </ModalBody>
            </Modal>

            <Modal
                show={showDiagnosisModal}
                centered
                size="xl">
                <ModalHeader>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShowDiagnosisModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <Diagnosis athltId={athleteId} injId={injuryId} />
                </ModalBody>
            </Modal>

            <Modal
                show={showTreatModal}
                centered
                size="xl">
                <ModalHeader>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShowTreatModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <Treatment athltId={athleteId} injId={injuryId} />
                </ModalBody>
            </Modal>
        </>
    );
};

export default Injury;